<template>
  <div>
    <a
      href="#"
      class="py-3 border-b border-gray-300 flex items-center justify-between text-white text-xl"
      @click.prevent="open = !open">
      <slot name="header" />
      <div
        class="arrow ml-auto"
        :class="{ 'is-open': open }" />
    </a>
    <transition-expand>
      <div
        class="db w-100 accordion-content"
        v-if="open">
        <div class="py-4">
          <slot name="content" />
        </div>
      </div>
    </transition-expand>
  </div>
</template>

<script>
import TransitionExpand from "@/components/TransitionExpand"

export default {
  components: {
    TransitionExpand
  },

  data () {
    return {
      open: false
    }
  }
}
</script>

<style lang="scss" scoped>
  .arrow {
    background: url('~@/assets/images/icon-plus.svg') center center no-repeat;
    background-size: 100% 100%;
    display: block;
    width: 16px;
    height: 16px;
    transition: all 350ms ease;
    fill: #fff;

    &.is-open {
      background: url('~@/assets/images/icon-minus.svg') center center no-repeat;
      background-size: 100% 100%;
      fill: #fff;
    }
  }
</style>

<style lang="scss">
  .accordion-content a {
    color: #fff;
    text-decoration: underline;

    &:hover {
      color: #ccc;
    }
  }
</style>
